import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IntervalService from './../../services/intervals';
import Grid from '@mui/material/Grid';
import settingsStore from '../../stores/settings';
import ToggleButton from '@mui/material/ToggleButton';
import SvgIcon from '@mui/material/SvgIcon';
import MenuItem from '@mui/material/MenuItem';
import Confirm from './../dialogs/Confirm';
import Menu from '@mui/material/Menu';
import SavePlayList from './../dialogs/SavePlayList';
import { ReactComponent as SmartQIcon } from './../../assets/smartq.svg';
import SmartQConfirmation from '../dialogs/SmartQConfirmation';
import DeleteDialog from './../dialogs/DeleteDialog';
import Tooltip from '@mui/material/Tooltip';
import sessionStore from '../../stores/session';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import messageStore from './../../stores/message';

function HistoryBottomBar(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const emptyPlayer = playerStore((state) => state.empty);
  const clearHistory = performanceStore((state) => state.clearHistory);

  useEffect(() => {

  }, []);

  const [isClearDialogOpen, setIsClearDialogOpen] = useState(false);

  const handleOpenClearDialog = () => {
    setIsClearDialogOpen(true);
  };

  const handleCloseClearDialog = () => {
    setIsClearDialogOpen(false);
  };

  const onClearing = () => {
    clearHistory(sessionToken);
    handleCloseClearDialog();
  };

  return (
    <Grid container spacing={0}>
      <DeleteDialog
        open={isClearDialogOpen}
        onClose={handleCloseClearDialog}
        onDeletion={onClearing}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_clear}
      />
      <Grid item xs={12} justifyContent="left">
        <Stack className="muvika-history-bottom-bar-stack" direction="row" spacing={2}>
          <Button color="secondary" onClick={handleOpenClearDialog}>{TR.cm_clear}</Button>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default HistoryBottomBar;